import { get } from "../api/apiClient";

export async function fetchGoogleAnalyticsDashboard(range = "7d") {
  // Backend is mounted at /api/google-analytics
  // apiClient baseURL already includes `/api` via REACT_APP_API_BASE_URL
  const params = new URLSearchParams();
  if (range) params.set("range", range);

  const qs = params.toString();
  const res = await get(`/google-analytics/dashboard${qs ? `?${qs}` : ""}`);

  // Expected backend shape:
  // { success: boolean, message: string, data: { users, events, trend } }
  return res;
}

export async function fetchFullDashboard(range = "7d") {
  const params = new URLSearchParams();
  if (range) params.set("range", range);
  const qs = params.toString();
  return get(`/google-analytics/full-dashboard${qs ? `?${qs}` : ""}`);
}

